const VALUES = {
    PICKING: "PICKING",
    VOTING: "VOTING",
    VETO: "VETO",
    DONE: "DONE"
}

export default VALUES

